<template>

  <div v-if="loged" class="admin-wrapper">

      <div class="container-scroller">

    <nav class="navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
      <div class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-start">
        <a class="navbar-brand brand-logo me-5" href="/"><img :src="this.$store.state.img_url + 'new_logo.png'" class="me-2"
            alt="logo" /></a>
        <a class="navbar-brand brand-logo-mini" href="/"><img :src="this.$store.state.img_url + 'sq_logo.png'"
            alt="logo" /></a>
      </div>
      <div class="navbar-menu-wrapper d-flex align-items-center justify-content-end">
        <button class="navbar-toggler navbar-toggler align-self-center" type="button" data-toggle="minimize">
          <span class="icon-menu"></span>
        </button>
        
        <div>
          <h3 class="p-3 text-primary">{{user.branch_name}}</h3>
        </div>
        <ul class="navbar-nav navbar-nav-right">
          <li class="nav-item nav-profile dropdown">
            <a class="nav-link dropdown-toggle" href="#" data-bs-toggle="dropdown" id="profileDropdown">
              <img  :src="$store.state.img_url + user.avator" alt="profile" />
            </a>
            <div class="dropdown-menu dropdown-menu-right navbar-dropdown" aria-labelledby="profileDropdown">
              <a href="/profile" class="dropdown-item">
                <i class="ti-user text-primary"></i> {{user.username}} </a>
              <button @click="logout" class="dropdown-item">
                <i class="ti-power-off text-primary"></i> Logout </button>
            </div>
          </li>

        </ul>
        <button class="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button"
          data-toggle="offcanvas">
          <span class="icon-menu"></span>
        </button>
      </div>
    </nav>
    <!-- partial -->
    <div class="container-fluid page-body-wrapper">
      <!-- partial:partials/_sidebar.html -->
      <nav class="sidebar sidebar-offcanvas" id="sidebar">
        <ul class="nav sidebar-nav">
          <li id="dashbord" class="nav-item">
             <router-link @click="navigateAndCloseMenu" class="nav-link" :to="{ path: '/' }">
              <i class="icon-grid menu-icon"></i>
              <span class="menu-title">Dashboard</span>
          </router-link>
          </li>

           <li  v-if="user.role < 4" class="nav-item">
            <a class="nav-link" data-bs-toggle="collapse" href="#package" aria-expanded="false"
              aria-controls="package">
              <i class="icon-layout menu-icon"></i>
              <span class="menu-title">Packages</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="package">
              <ul class="nav flex-column sub-menu">
                <li id="add-package" class="nav-item"> <router-link @click="navigateAndCloseMenu" class="nav-link" :to="{ path: '/add-package' }">Add Package</router-link></li>
                <li id="incoming-packages" class="nav-item"> <router-link @click="navigateAndCloseMenu" class="nav-link" :to="{ path: '/incomming-parcels' }">Incoming Parcels</router-link></li>
                <li id="outgoing-packages" class="nav-item"> <router-link @click="navigateAndCloseMenu" class="nav-link" :to="{ path: '/outgoing-parcels' }">Outgoing Parcels</router-link></li>
            <!--userInfo.user.role 2-->
                <li v-if="user.role == 2" id="package-reports" class="nav-item"> <router-link @click="navigateAndCloseMenu" class="nav-link" :to="{ path: '/bm-received-reports' }">Received Reports</router-link></li>
                 <!--li v-if="user.role == 2" id="package-reports" class="nav-item"> <router-link @click="navigateAndCloseMenu" class="nav-link" :to="{ path: '/bm-removed-packages' }">Removed Packages</router-link></li-->
         <!--end userInfo.user.role 2-->
             <!--userInfo.user.role 3-->
                <li v-if="user.role == 3" id="transit-reports" class="nav-item"> <router-link @click="navigateAndCloseMenu" class="nav-link" :to="{ path: '/transit-reports' }">Transit Reports</router-link></li>
                <li v-if="user.role == 3" id="package-reports" class="nav-item"> <router-link @click="navigateAndCloseMenu" class="nav-link" :to="{ path: '/received-reports' }">Received Reports</router-link></li>
                <li v-if="user.role > 1 && user.role < 4" id="removed-packages" class="nav-item"> <router-link @click="navigateAndCloseMenu" class="nav-link" :to="{ path: '/removed-packages' }">Removed Parcels</router-link></li>
             <!--end userInfo.user.role 3--> 
                <li id="find-packages" class="nav-item"> <router-link @click="navigateAndCloseMenu" class="nav-link" :to="{ path: '/search-page' }">Search Parcels</router-link></li>
              </ul>
            </div>
          </li>

           <li v-if="user.role > 1 && user.role < 4" class="nav-item">
            <a class="nav-link" data-bs-toggle="collapse" href="#customer" aria-expanded="false"
              aria-controls="customer">
              <i class="icon-layout menu-icon"></i>
              <span class="menu-title">C Services</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="customer">
              <ul class="nav flex-column sub-menu">
  
                <li id="service-team" class="nav-item"> <router-link @click="navigateAndCloseMenu" class="nav-link" :to="{ path: '/service-team' }">Service Team</router-link></li>
                <li id="service-report" class="nav-item"> <router-link @click="navigateAndCloseMenu" class="nav-link" :to="{ path: '/service-report' }">Service Report</router-link></li>
             </ul>
            </div>
          </li>

          <li v-if="user.role > 1 && user.role < 4" class="nav-item">
            <a class="nav-link" data-bs-toggle="collapse" href="#sales" aria-expanded="false"
              aria-controls="sales">
              <i class="icon-layout menu-icon"></i>
              <span class="menu-title">Sales</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="sales">
              <ul class="nav flex-column sub-menu">
  
                <li id="branches-sales" class="nav-item"> <router-link @click="navigateAndCloseMenu" class="nav-link" :to="{ path: '/branches-sales' }">Branches Sales</router-link></li>
                <li id="sales-records" class="nav-item"> <router-link @click="navigateAndCloseMenu" class="nav-link" :to="{ path: '/sales-records' }">Sales Records</router-link></li>
             </ul>
            </div>
          </li>

     <!--userInfo.user.role 2>
               <li id="branches" class="nav-item">
            <a class="nav-link" href="/bm-revenue-report">
              <i class="icon-paper menu-icon"></i>
              <span class="menu-title">Revenue Reports</span>
            </a>
          </li-->
        <!--userInfo.user.role 3-->
               <li id="revenues" v-if="user.role == 3" class="nav-item">
            <router-link @click="navigateAndCloseMenu" class="nav-link" :to="{ path: '/revenue-reports' }">
              <i class="icon-paper menu-icon"></i>
              <span class="menu-title">Revenue Reports</span>
            </router-link>
          </li>
<!--userInfo.user.role 1-->
               <li id="messages" v-if="user.role > 1 && user.role < 4" class="nav-item">
            <router-link @click="navigateAndCloseMenu" class="nav-link" :to="{ path: '/message-report' }">
              <i class="icon-paper menu-icon"></i>
              <span class="menu-title">Message Reports</span>
            </router-link>
          </li>
          
<!--userInfo.user.role 3-->

<li id="my-incomming"  v-if="user.role == 4" class="nav-item">
              <router-link @click="navigateAndCloseMenu" class="nav-link" :to="{ path: '/my-incomming-parcels' }">
              <i class="icon-paper menu-icon"></i>
              <span class="menu-title">Incomming Parcels</span>
           </router-link>
          </li>
 
  <li id="my-service-report" v-if="user.role == 4" class="nav-item">
              <router-link @click="navigateAndCloseMenu" class="nav-link" :to="{ path: '/my-service-report' }">
              <i class="icon-paper menu-icon"></i>
              <span class="menu-title">My Service Report</span>
           </router-link>
          </li>

          <li id="service-team-report" v-if="user.role == 4" class="nav-item">
              <router-link @click="navigateAndCloseMenu" class="nav-link" :to="{ path: '/service-team-report' }">
              <i class="icon-paper menu-icon"></i>
              <span class="menu-title">Team Reports</span>
           </router-link>
          </li>

          <li id="branches" class="nav-item">
              <router-link @click="navigateAndCloseMenu" class="nav-link" :to="{ path: '/branches' }">
              <i class="icon-paper menu-icon"></i>
              <span class="menu-title">Destination Branches</span>
           </router-link>
          </li>
        
         
          <li id="staff_members" class="nav-item">
            <router-link @click="navigateAndCloseMenu" class="nav-link" :to="{ path: '/staffs' }">
              <i class="icon-paper menu-icon"></i>
              <span class="menu-title">Staff Members</span>
            </router-link>
          </li>

          <li v-if="user.role > 1 && user.role < 4" id="customers" class="nav-item">
           <router-link @click="navigateAndCloseMenu" class="nav-link" :to="{ path: '/customers' }">
              <i class="icon-paper menu-icon"></i>
              <span class="menu-title">Customers</span>
           </router-link>
          </li>

          <li id="profiles" class="nav-item">
            <a class="nav-link" data-bs-toggle="collapse" href="#profile" aria-expanded="false"
              aria-controls="profile">
              <i class="icon-layout menu-icon"></i>
              <span class="menu-title">User Profile</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="profile">
              <ul class="nav flex-column sub-menu">
                <li class="nav-item">   <router-link @click="navigateAndCloseMenu" class="nav-link" :to="{ path: '/profile' }">Profile</router-link></li>
                <li class="nav-item"> <button class="nav-link" @click="logout">Logout</button></li>
              </ul>
            </div>
          </li>

          <!--li id="notification" class="nav-item">
            <a class="nav-link" href="/notification">
              <i class="icon-paper menu-icon"></i>
              <span class="menu-title">Notifications</span>
            </a>
          </li-->
        </ul>
      </nav>
      <!-- partial -->
      <div class="main-panel">
       <router-view :user="this.user" :key="$route.fullPath" />

        <footer class="footer">
          <div class="d-sm-flex justify-content-center justify-content-sm-between">
            <span class="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2025 Usiri Transportation Servives Limited.<br> Developed and Managed by (0686255811)<a
                href="https://www.akilikubwadigital.com/" target="_blank"> akilikubwadigital</a>.
              All rights reserved.</span>
          </div>
        </footer>
        <!-- partial -->
      </div>
      <!-- main-panel ends -->
    </div>
    <!-- page-body-wrapper ends -->
  </div>

  </div>

  <!-- Page wrapper ends min-h-screen -->

  <div v-if="!loged" class="">
    <Authentication />
  </div>


</template>

<script>
import axios from "axios";
import * as CryptoJS from 'crypto-js';
import Authentication from "./views/auth/Authentication.vue";
//import Verify from "./views/auth/Verify.vue";
//import JoinForm from "./views/JoinForm.vue"


export default {
  components: {
    Authentication,
  },
  data() {
    return {
      loged: false,
      user: {
        fullname: "Sambokile Andy",
        auth_statuses_id: 0
      },
    };
  },
  methods: {

   
    navigateAndCloseMenu() {
    if (window.innerWidth < 992) {
        const sidebar = document.querySelector('.sidebar');

        if (sidebar) {
            sidebar.classList.remove('active');
        }
    }
},
    isLoged() {
      //var user = localStorage.getItem("user");
      var user_cry = localStorage.getItem("user") || "";
      var token_cry = localStorage.getItem("user_token") || "";
      var user = CryptoJS.AES.decrypt(user_cry, 'user').toString(CryptoJS.enc.Utf8) || null
      var token = CryptoJS.AES.decrypt(token_cry, 'user_token').toString(CryptoJS.enc.Utf8) || null


      if (user && token) {
        this.loged = true;
        this.user = JSON.parse(user);
        console.log(JSON.parse(user))
      } else {
        localStorage.removeItem("user_token")
        localStorage.removeItem("user")
        this.loged = false;
      }
    },
    logout() {
      this.$store.dispatch("logOut", { id: this.user.id, company_id: this.user.company_id });
    },
  },
  created() {

    this.isLoged();
    //alert(localStorage.getItem("user"));
    //this.reload();
    var token_cry = localStorage.getItem("user_token") || "";
    var token = CryptoJS.AES.decrypt(token_cry, 'user_token').toString(CryptoJS.enc.Utf8) || null
    axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
    axios.defaults.headers.common["Authorization"] = token
  },
  mounted() {

  }

};

</script>